import logo from './assets/logo.png';
import pic_cristina from './assets/pic_cristina.png';
import {Routes, Route, NavLink, useLocation} from "react-router-dom";
import {AnimatePresence, motion} from "framer-motion";
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import ChiSono from "./components/ChiSono";
import Servizi from "./components/Servizi";
import Notizie from "./components/Notizie";
import Contatti from "./components/Contatti";
import CookieBanner from "./components/CookieBanner";
import React from "react";

function App() {
    const location = useLocation();
    const year = new Date().getFullYear();

    const hideCookiesPolicy = () => {
        document.getElementById('cookiePolicyDiv').style.display = 'none';
    };

    return (
        <div>
            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <div className="container">

                    {/* Bottone hamburger visibile su schermi piccoli */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mx-auto">
                            <li className="nav-item"><NavLink className="nav-link" to="/chi-sono">Chi sono</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/servizi">Servizi</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/notizie">Notizie</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to="/contatti">Contatti</NavLink></li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Hero */}
            <header className="darkContainer">
                <div className="container containerHeader">
                    <div className="row">
                        {/* Colonna sinistra */}
                        <div className="col-md-6 text-md-start text-center">
                            <div className={'logo-container align-content-hcenter'}>
                                <a href={'/#/chi-sono'}>
                                    <img src={logo} className="logoCls" alt="logo studio legale"/>
                                </a>
                            </div>
                            <div className="display-5 white-color align-content-hcenter">Avvocato civilista</div>
                            <div className={'top-margin-5 align-content-hcenter'}>
                                <span className={'display-6 light-color'}>Maria Cristina Montis</span>
                            </div>
                            <div className={'top-margin-15 align-content-hcenter'}>
                                <FontAwesomeIcon icon={faLocationDot} size="1x" className="mb-1" />
                                <span className={'display-7 white-color left-margin-5'}>Milano</span>
                            </div>
                        </div>
                        {/* Colonna destra */}
                        <div className="col-md-6 text-md-start text-center">
                            <div className={'logo-container'}>
                                <img src={pic_cristina} className="picCristinaCls" alt="logo studio legale"/>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Routes */}
            <AnimatePresence mode="wait">
                <Routes location={location} key={location.pathname}>

                    <Route
                        path="/chi-sono"
                        element={
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 50 }}
                                transition={{ duration: 0.4 }}
                            >
                                <ChiSono />
                            </motion.div>
                        }
                    />
                    <Route
                        path="/servizi"
                        element={
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -50 }}
                                transition={{ duration: 0.4 }}
                            >
                                <Servizi />
                            </motion.div>
                        }
                    />
                    <Route
                        path="/notizie"
                        element={
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -50 }}
                                transition={{ duration: 0.4 }}
                            >
                                <Notizie />
                            </motion.div>
                        }
                    />
                    <Route
                        path="/contatti"
                        element={
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -50 }}
                                transition={{ duration: 0.4 }}
                            >
                                <Contatti />
                            </motion.div>
                        }
                    />

                    <Route
                        path="/"
                        element={
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 50 }}
                                transition={{ duration: 0.4 }}
                            >
                                <ChiSono />
                            </motion.div>
                        }
                    />
                </Routes>
            </AnimatePresence>

            {/* Footer */}

            <div id={"cookiePolicyDiv"} className={location.pathname === "/cookie-policy" ? "show" : "hide"}>
                <section className="py-5 darkerContainer white-color bottom-margin-50">
                    <div className="container">
                        <h2>Cookie Policy</h2>
                        <p>
                            Ai sensi del Regolamento (UE) 2016/679 (“GDPR”) e del Provvedimento del Garante
                            per la protezione dei dati personali dell’8 maggio 2014, si informa l’utente che
                            questo sito non utilizza cookie propri di profilazione o marketing.
                        </p>

                        <h3>Tipologie di cookie utilizzati</h3>
                        <p>
                            L’unico utilizzo di cookie riguarda servizi di terze parti, in particolare
                            <strong>Google Maps</strong>, integrato per mostrare la posizione dello Studio.
                            Tali cookie sono gestiti direttamente da Google e possono raccogliere
                            informazioni
                            sull’utilizzo della mappa da parte dell’utente.
                        </p>

                        <h3>Finalità</h3>
                        <p>
                            I cookie di Google Maps sono considerati cookie tecnici/di terze parti,
                            necessari
                            al corretto funzionamento del servizio di geolocalizzazione. Non vengono
                            utilizzati
                            per finalità di profilazione da parte del titolare del sito.
                        </p>

                        <h3>Base giuridica</h3>
                        <p>
                            La base giuridica del trattamento è l’interesse legittimo del titolare a fornire
                            un servizio di localizzazione dello Studio, ai sensi dell’art. 6, par. 1, lett.
                            f) GDPR.
                        </p>

                        <h3>Gestione dei cookie</h3>
                        <p>
                            L’utente può in qualsiasi momento disabilitare i cookie di terze parti
                            attraverso
                            le impostazioni del proprio browser. Si segnala che la disattivazione potrebbe
                            limitare alcune funzionalità della mappa.
                        </p>

                        <h3>Informazioni di terze parti</h3>
                        <p>
                            Per maggiori dettagli sui cookie di Google Maps e sulle modalità di gestione,
                            si invita a consultare la <a href="https://policies.google.com/privacy"
                                                         target="_blank" rel="noreferrer">
                            Privacy Policy di Google</a>.
                        </p>

                        <h3>Diritti dell’interessato</h3>
                        <p>
                            L’utente ha diritto di accedere ai propri dati personali, chiederne la rettifica
                            o la cancellazione, limitarne il trattamento o opporsi, nei casi previsti dal
                            GDPR.
                            Può inoltre proporre reclamo al Garante per la protezione dei dati personali.
                        </p>

                        <button onClick={hideCookiesPolicy} className="btn btn-primary btn-sm">
                            Chiudi
                        </button>
                    </div>
                </section>
            </div>

            <footer>
                <p>&copy; <span id={'yearId'}>{year}</span> Studio Legale Avv. Maria Cristina Montis - Tutti i diritti
                    riservati</p>
            </footer>

            <CookieBanner/>
        </div>
    );
}

export default App;
